let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i4r9Y")).then(() => parcelRequire('6re9h'));